import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DeliveryStepsService } from '../../../services/delivery-steps.service';
import { AddressModel } from '../../../../shared/models/address.model';
import { isNullOrUndefined } from 'util';
import { AuthenticatedUserRepositoryService } from '../../../services/authenticated-user-repository.service';

@Component({
    selector: 'payment-delivery-addresses-address-new',
    templateUrl: './payment.delivery.addresses.address-new.component.html',
    styleUrls: ['../../../payment.component.scss']
})
export class PaymentDeliveryAddressesAddressNewComponent {
    public model: AddressModel = new AddressModel;
    public addressFoundAtApi = false;
    public loading = false;
    public apiErrors = {};

    @Input() creatingAddressZipCode = '';
    @Input() addressToUpdate: AddressModel = null;
    @Output() onAddressCreated = new EventEmitter<AddressModel>();
    @Output() onAddressUpdated = new EventEmitter<AddressModel>();

    constructor(
        protected deliveryStepsService: DeliveryStepsService,
        protected authenticatedUserService: AuthenticatedUserRepositoryService
    ) {
        this.model.zip_code = '';
        this.authenticatedUserService.resetedUser$.subscribe(() => {
            this.model = new AddressModel;
        });
    }

    /**
     * submitted event listener.
     **/
    public onSubmitted(address: AddressModel): void {
        this.loading = true;
        this.model = address;
        this.apiErrors = {};
        if (isNullOrUndefined(this.model.id)) {
            this.create();
        } else {
            this.update();
        }
    }
    /**
     * findingZipCode event listener.
     **/
    public onFindingZipCode(zipCode) {
        this.loading = true;
    }
    /**
     * foundZipCode event listener.
     **/
    public onFoundZipCode(zipCode) {
        this.addressFoundAtApi = true;
        this.loading = false;
    }
    /**
     * notFoundZipCode event listener.
     **/
    public onNotFoundZipCode(zipCode) {
        this.addressFoundAtApi = false;
        this.loading = false;
    }
    /**
     * This call create address API endpoint
     **/
    private create() {
        this.deliveryStepsService.create(this.model).subscribe(() => {
            this.creatingAddressZipCode = '';
            this.loading = false;
            this.addressFoundAtApi = false;
            this.onAddressCreated.emit(this.model);
        }, (errors) => {
            this.loading = false;
            this.apiErrors = errors;
        });
    }
    /**
     * This call delete and create address API endpoints, for update.
     **/
    private update() {
        this.deliveryStepsService.update(this.model).subscribe(() => {
            this.addressToUpdate = null;
            this.loading = false;
            this.addressFoundAtApi = false;
            this.onAddressUpdated.emit(this.model);
        }, (errors) => {
            this.loading = false;
            this.apiErrors = errors;
        });
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src2645790472/src/src/app/payment/delivery/addresses/address-new/payment.delivery.addresses.address-new.component.ts